import { z } from 'zod';

export const ImpersonationAccountPickerModalFormSchema = z.object({
  ACCOUNT_ID: z.string().uuid(),
});

export type ImpersonationAccountPickerModalForm = z.infer<
  typeof ImpersonationAccountPickerModalFormSchema
>;
